import { UserRole } from '@ti/contracts'

export const FLESPI_TOKEN_STORAGE_KEY = 'FLESPI_TOKEN'

export type BaseDeviceTelemetry = Record<string, any> & {
  deviceId: number
  isConnected?: boolean
  inSleepMode?: boolean
  altitude?: number
  direction?: number
  latitude?: number
  longitude?: number
  speed?: number
  address?: string
  // The time of the last update received
  timestamps?: Partial<{
    position?: number
    isConnected?: number
  }>
}

export type FlespiTopicMessage<T = any> = {
  data: T
  topic: string
  topicData: Record<string, any>
  userProperties: {
    cid: string
    timestamp: string
  }
}

export type FlespiTelemetryData = Record<string, { ts: number; value: any }>

export interface FlespiDeviceTelemetryResponse {
  result: Array<{ id: number; telemetry: FlespiTelemetryData }>
}

export type FlespiSubscriptionRef = { destroy: () => void }

export type CachedFlespiTokenData = {
  id: number
  key: string
  expire: number
  metadata: {
    account_id: number
    level: string
    user_id: string
    user_role_id: UserRole
  }
}
